export default function (initialEnum: any, value: any): string {
  return Object.keys(initialEnum)[Object.values(initialEnum).indexOf(value)];
}
